import {
  AlertTriangle,
  CheckCircle2,
  CreditCard,
  DollarSign,
  Gamepad2,
  Gem,
  Handshake,
  Lock,
  LockKeyhole,
  MessageCircle,
  Package,
  Rocket,
  Search,
  Shield,
  Star,
  Zap,
  type LucideIcon,
} from 'lucide-react'

/** Default icon tint when no parent `color` is set. */
export const ICON_BRAND = 'text-[#8ecfff]'

const MAP = {
  zap: Zap,
  lock: Lock,
  gamepad: Gamepad2,
  gem: Gem,
  check: CheckCircle2,
  rocket: Rocket,
  shield: Shield,
  package: Package,
  message: MessageCircle,
  money: DollarSign,
  handshake: Handshake,
  star: Star,
  search: Search,
  card: CreditCard,
  lockKey: LockKeyhole,
  alert: AlertTriangle,
} satisfies Record<string, LucideIcon>

export type FeatureIconName = keyof typeof MAP

/** @deprecated Use ICON_BRAND */
export const ICON_PINK = ICON_BRAND

export function FeatureIcon({
  name,
  className = '',
  size = 20,
  strokeWidth = 2,
}: {
  name: FeatureIconName
  className?: string
  size?: number
  strokeWidth?: number
}) {
  const Cmp = MAP[name]
  const classes = className.trim() || ICON_BRAND
  return <Cmp className={`shrink-0 ${classes}`} size={size} strokeWidth={strokeWidth} aria-hidden />
}

export function StarRating({
  rating,
  size = 16,
  className = '',
}: {
  rating: number
  size?: number
  className?: string
}) {
  const full = Math.round(rating)
  return (
    <div className={`flex gap-0.5 items-center ${className}`} aria-hidden>
      {[...Array(5)].map((_, i) => (
        <Star
          key={i}
          size={size}
          className={i < full ? 'text-[#00bfff]' : 'text-[#5a6d8a]'}
          fill={i < full ? 'currentColor' : 'none'}
          stroke="currentColor"
          strokeWidth={2}
          style={{ opacity: i < full ? 1 : 0.35 }}
        />
      ))}
    </div>
  )
}

/** @deprecated Use StarRating */
export const StarRatingPink = StarRating
